// extracted by mini-css-extract-plugin
export default {"stickySave":"GeneralSettings_stickySave__MEfSj"};